import { Component } from '@angular/core';
import { GlobalService } from '@app/services/global.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: false,
})
export class LoaderComponent {
  isLoading$ = this.globalService.getMainLoading();
  isMobile: boolean = false;
  constructor(private globalService: GlobalService) { }

    ngOnInit() {
    this.isMobile = this.globalService.isMobile();
  }
}
